/**
 * Cross-app audit correlation (SOC2 CR-12).
 *
 * Sends the originating app (`x-tento-app`) + a stable per-tab-session id
 * (`x-tento-flow-id`) on every backend call so the backend audit trail can
 * reconstruct a whole apply journey, and an admin can filter it by that one
 * journey end-to-end.
 */

const FLOW_ID_KEY = 'tento-flow-id';

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

/** Per-tab-session correlation id; '' when not in a browser. */
export function getTentoFlowId(): string {
  if (typeof window === 'undefined') return '';
  try {
    let id = window.sessionStorage.getItem(FLOW_ID_KEY);
    if (!id) {
      id = generateId();
      window.sessionStorage.setItem(FLOW_ID_KEY, id);
    }
    return id;
  } catch {
    return '';
  }
}

/** Correlation headers to attach to outbound backend requests. */
export function tentoAuditHeaders(): Record<string, string> {
  const headers: Record<string, string> = { 'x-tento-app': 'apply' };
  const flowId = getTentoFlowId();
  if (flowId) headers['x-tento-flow-id'] = flowId;
  return headers;
}
